import WithSidebar from 'Layout/WithSidebar';
import GeneralInfoBox from 'components/GeneralInfoBox';
import NavigationSideBar from 'components/NavigationSideBar';
import Banner from 'components/Banner';
import legalInfoBanner from 'images/legal-info-banner.jpg';
import NavigationSectionWrapper from 'components/NavigationSideBar/NavigationSectionWrapper';
import React from 'react';
import { calculateActiveIndex } from 'components/NavigationSideBar/helpers';
import { titles } from './mockData';

const LegalInfo = () => {
    const [sectionsData, setSectionsData] = React.useState({});
    const [activeIndex, setActiveIndex] = React.useState(0);

    const pageContent = [
        <GeneralInfoBox>
            <h3>Legal info about the company</h3>
            <hr />
            <h5>Initial data</h5>
            <p>Strandstrasse 6</p>
            <p>UniferX International GmbH</p>
            <p>18211 Nienhagen</p>
            <p>Mecklenburg-Vorpommern</p>
            <p>Phone: +49 173 762 7701</p>
            <p>E-Mail: info@uniferx.com</p>
            <hr />
            <h5>The company's management:</h5>
            <p>General Director Anzhelika Rakov</p>
            <p>General Director Dr. Dirk Rakov</p>
            <p>General Director Olga Chupryna</p>
            <p>General Director Sören von Nolting</p>
            <hr />
            <h5>Registration:</h5>
            <p>The court that carried out the registration: </p>
            <p>District Court of the city of Rostock</p>
            <p>Registration number: HRB 10793</p>
            <hr />
            <h5>Tax number:</h5>
            <p>Tax number in accordance with §27a </p>
            <p>of the German Sales Tax Act:</p>
            <p>DE 257739107</p>
        </GeneralInfoBox>,
        <GeneralInfoBox>
            <h3>General terms and conditions</h3>
            <p>
                Access to and use of this website is subject to the following requirements. Please do not use this
                website if you do not agree to these terms. This website was developed and is operated by the UniferX
                group of companies.
            </p>
            <p>
                We reserve the right to discontinue this site or to make changes to this site or to the Terms of Use, in
                whole or in part. Please note that we may make such changes at our sole discretion without prior notice.
                Therefore, we ask you: the next time you visit our website, please review the terms and conditions again
                and note any changes or corrections that may have been made.
            </p>
        </GeneralInfoBox>,
    ];

    const arrLength = pageContent.length;
    const [refs, setRefs] = React.useState([]);

    React.useEffect(() => {
        setRefs(refs =>
            Array(arrLength)
                .fill()
                .map((_, i) => refs[i] || React.createRef()),
        );
    }, [arrLength]);

    React.useEffect(() => {
        setActiveIndex(calculateActiveIndex(sectionsData));
    }, [sectionsData]);

    return (
        <>
            <Banner title="Legal info" image={legalInfoBanner} buttonText="Read more" />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    Sidebar={<NavigationSideBar activeIndex={activeIndex} items={titles} refs={refs} />}
                >
                    {pageContent.map((item, index) => (
                        <div ref={refs[index]} key={index}>
                            <NavigationSectionWrapper index={index} setData={setSectionsData}>
                                {item}
                            </NavigationSectionWrapper>
                        </div>
                    ))}
                </WithSidebar>
            </section>
        </>
    );
};

export default LegalInfo;
